/**
 * Minutos até a 1ª resposta da equipe (cliente → atendente), por conversa.
 */

import { supabase } from '../../../lib/supabase';

const CHUNK = 80;
const MAX_MESSAGES_PER_CHUNK = 8_000;

export type FirstResponseMap = Map<string, number | null>;

/**
 * `null` = houve mensagem do cliente e nenhuma da equipe depois.
 * ausente no mapa = sem mensagem do cliente mensurável.
 */
export async function fetchFirstResponseMinutesByConversationIds(
    conversationIds: string[],
    organizationId?: string
): Promise<FirstResponseMap> {
    const result: FirstResponseMap = new Map();
    if (!conversationIds.length) return result;

    for (let i = 0; i < conversationIds.length; i += CHUNK) {
        const chunk = conversationIds.slice(i, i + CHUNK);
        let query = supabase
            .from('chat_messages')
            .select('conversation_id, sender, timestamp')
            .in('conversation_id', chunk)
            .order('timestamp', { ascending: true })
            .limit(MAX_MESSAGES_PER_CHUNK);

        if (organizationId) {
            query = query.eq('organization_id', organizationId);
        }

        const { data, error } = await query;
        if (error) {
            console.error('[aiChatContext] first response:', error.message);
            continue;
        }

        const firstCustomer = new Map<string, number>();
        const firstAgentAfterCustomer = new Map<string, number>();

        for (const row of data ?? []) {
            const id = row.conversation_id as string;
            const ts = new Date(row.timestamp as string).getTime();
            if (Number.isNaN(ts)) continue;

            if (row.sender === 'me') {
                const customerAt = firstCustomer.get(id);
                if (customerAt !== undefined && !firstAgentAfterCustomer.has(id) && ts >= customerAt) {
                    firstAgentAfterCustomer.set(id, ts);
                }
                continue;
            }

            if (!firstCustomer.has(id)) {
                firstCustomer.set(id, ts);
            }
        }

        for (const id of chunk) {
            const customerAt = firstCustomer.get(id);
            if (customerAt === undefined) continue;
            const agentAt = firstAgentAfterCustomer.get(id);
            if (agentAt === undefined) {
                result.set(id, null);
                continue;
            }
            const minutes = Math.max(0, Math.round((agentAt - customerAt) / 60_000));
            result.set(id, minutes);
        }
    }

    return result;
}
